export const letterIds = ["red", "yellow", "blue"];

export const labels = {
  dev: ['full-stack', 'front-end', 'self-taught', 'react', 'creative'],
  verb: ['builds', 'codes', 'designs', 'creates', 'delivers']
}

export const letters = {
  pablo: ["P", "a", "b", "l", "o"],
  gastelum: ["G", "a", "s", "t", "e", "l", "u", "m"]
}

export const blankLetters = {
  firstName: ["", "", "", "", ""],
  lastName: ["", "", "", "", "", "", "", ""]
}